import { observer } from "mobx-react-lite";
import React from "react";
import Layout from "../../components/Layout/Layout";

export const ContentView = observer((props) => {
  return (
    <div className="content-view">
      <Layout scoped={true} />
    </div>
  );
});
